import request from '@/api/fetcher/request'

/**
 * 历史消息
 * @returns
 */
export function fetchHistoryList () {
  return request.post('/api/sdk/user/message/center/history', {})
}

/**
 * 未读消息总数
 * @returns
 */
export function fetchTotalCount () {
  return request.post('/api/sdk/user/message/center/count')
}

/**
 * 删除消息
 * @param {*} msg_id
 * @returns
 */
export function deleteHistoryItem (msg_id) {
  return request.post('/api/sdk/user/message/center/delete', { msg_id })
}

/**
 * 获取游标后的信息数
 * @param {*} msg_id
 * @returns
 */
export function fetchCursor (msg_id = '0') {
  return request.post('/api/sdk/user/message/center/cursor', { msg_id })
}

/**
 * 获取用户最后阅读的游标ID
 * @returns
 */
export function getLastMsgId () {
  return request.post('/api/sdk/user/message/center/get_latest_msg_id', {}).then((res) => { return res.latest_msg_id })
}

/**
 * 设置用户最后阅读的游标
 * @param {*} latest_msg_id
 * @returns
 */
export function setLastMsgId (latest_msg_id) {
  return request.post('/api/sdk/user/message/center/update_latest_msg_id', { latest_msg_id })
}
